export const pageTypeReducer = (state = "", action) => {
	if(action.type === 'PAGE_TYPE') {
		return action.payload || '';
    }

    return state;
}